import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {BLEND_MODES} from "pixi.js";
import {BruteForce} from "../BruteForce";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class BruteForceIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xNudge: true,
        xBet: true,
        volatility: Volatility.EXTREME
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];
    arcadeBg: PIXI.Sprite;
    nudgeCounter: PIXI.Sprite;

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);

        imgLoader.add("feature1", "resources/images/Intro_Feature_1.png");
        imgLoader.add("feature2", "resources/images/Intro_Feature_2.png");
        imgLoader.add("feature3", "resources/images/Intro_Feature_3.png");
        imgLoader.add("feature4", "resources/images/Intro_Feature_4.png");
        imgLoader.add("arcadeBox", "resources/images/foreground.png");
        imgLoader.add("screenBG", "resources/images/screenBG.jpg");
        imgLoader.add("texture", "resources/images/texture.jpg");
        imgLoader.add("nudgeCounter", "resources/images/nudgeCounter.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    public onShow() {
        this.pages.forEach((item) => {
            item.scale.set(0.8);
            item.parent.position.set(0, 173);
            const itemParent = item.parent.getChildByName("_pageBackgroundContainer");
            (itemParent as PIXI.Container).children.forEach((child: PIXI.DisplayObject) => {
                itemParent.scale.y = 4;
            })
        });
        this.borderBottom.position.set(0, 220);
        this.background.position.set(360, 300);
    }

    onResize() {
        NolimitApplication.isLandscape ? this.nudgeCounter.position.set(-462, -137): this.nudgeCounter.position.set(-286, -390);
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const sprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("screenBG"));
        sprite.anchor.set(0.5, 0.5);
        sprite.scale.set(1.2, 1.2);
        sprite.position.set(0, 50);
        this.background.addChild(sprite);
        this.background.name = "iambg";
        this.borderTop = new PIXI.Container();
        this.borderTop.name = "iamtopdivider";
        this.borderBottom = new PIXI.Container();
        this.borderBottom.name = "iambottomdivider"
        this.logo = new PIXI.Container();
        this.logo.name = "iamlogo";


        this.pages = [
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
        ];

        const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
        featureSprite1.anchor.set(0.5, 0.5);
        this.addTextureOverlay(featureSprite1);
        this.pages[0].addChild(featureSprite1);
        const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
        featureSprite2.anchor.set(0.5, 0.5);
        this.addTextureOverlay(featureSprite2);
        this.pages[1].addChild(featureSprite2);
        const featureSprite3 = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));
        featureSprite3.anchor.set(0.5, 0.5);
        this.addTextureOverlay(featureSprite3);
        this.pages[2].addChild(featureSprite3);

        if (BruteForce.apiPlugin.gameClientConfiguration.isSet) {
            this.showWincapPage();
        } else {
            BruteForce.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.showWincapPage();
            });
        }

        this.nudgeCounter = new PIXI.Sprite(ImgLoader.getImgTexture("nudgeCounter"));
        this.nudgeCounter.anchor.set(0.5, 0.5);
        // NolimitApplication.isLandscape ? this.nudgeCounter.position.set(-462, -137): this.nudgeCounter.position.set(-286, -390);
        this.nudgeCounter.name = "nudgeCounter";



        this.arcadeBg = new PIXI.Sprite(ImgLoader.getImgTexture("arcadeBox"));
        this.arcadeBg.anchor.set(0.5);
        this.arcadeBg.position.set(-5, 28);
        this.arcadeBg.name = "arcadeMachine";
        this.borderBottom.addChild(this.arcadeBg, this.nudgeCounter);
    }

    private addTextureOverlay(featureImage: PIXI.Sprite): void {
        const textureHorizontal: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("texture"));
        textureHorizontal.anchor.set(0.5);
        textureHorizontal.blendMode = BLEND_MODES.MULTIPLY;
        textureHorizontal.alpha = 0.2;
        textureHorizontal.position.set(0, 0);
        textureHorizontal.name = "textureHorizontal";


        featureImage.addChild(textureHorizontal);
        featureImage.position.set(0, 58);
        featureImage.scale.set(1.2, 1.2);
    }


    private showWincapPage(): void {
        if (!BruteForce.apiPlugin.gameClientConfiguration.replaceWincapInfo) {
            const featureSprite4 = new PIXI.Sprite(ImgLoader.getImgTexture("feature4"));
            featureSprite4.anchor.set(0.5, 0.5);
            this.addTextureOverlay(featureSprite4);
            const page = new SlideShowPage();
            page.addChild(featureSprite4)
            this.pages.splice(3, 0, page);
        }
    }
}